import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "getItemTagName", "getItemAttributes", "getItemIcon", "getItemLabel", "getItemOnClick", "onEsc", "onItemClick", "anchorRef", "isOpen", "className", "isProportional"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import { combineRefs } from '@carnica/utils';
import { cnBem } from "../../lib";
import { Popover } from "../Popover";
import styles from "./styles.pcss";
import { withDefaultGetters } from "./helpers";
import { ContextMenuItem } from "./ContextMenuItem";
import { useContextMenuNavigation } from "./hooks/useContextMenuNavigation";
var cnContextMenu = cnBem('context-menu', styles);
export var ContextMenu = /*#__PURE__*/forwardRef(function (props, ref) {
  var _withDefaultGetters = withDefaultGetters(props),
    _withDefaultGetters$i = _withDefaultGetters.items,
    items = _withDefaultGetters$i === void 0 ? [] : _withDefaultGetters$i,
    getItemTagName = _withDefaultGetters.getItemTagName,
    getItemAttributes = _withDefaultGetters.getItemAttributes,
    getItemIcon = _withDefaultGetters.getItemIcon,
    getItemLabel = _withDefaultGetters.getItemLabel,
    getItemOnClick = _withDefaultGetters.getItemOnClick,
    onEsc = _withDefaultGetters.onEsc,
    onItemClick = _withDefaultGetters.onItemClick,
    anchorRef = _withDefaultGetters.anchorRef,
    isOpen = _withDefaultGetters.isOpen,
    _className = _withDefaultGetters.className,
    isProportional = _withDefaultGetters.isProportional,
    otherProps = _objectWithoutProperties(_withDefaultGetters, _excluded);
  var _useContextMenuNaviga = useContextMenuNavigation({
      items: items,
      anchorRef: anchorRef,
      onEsc: onEsc,
      isOpen: isOpen
    }),
    refs = _useContextMenuNaviga.refs,
    containerRef = _useContextMenuNaviga.containerRef,
    activeIndex = _useContextMenuNaviga.activeIndex,
    onKeyDown = _useContextMenuNaviga.onKeyDown;
  var renderItem = function renderItem(item, i) {
    var _getItemAttributes;
    var onClick = function onClick(e) {
      var _getItemOnClick;
      (_getItemOnClick = getItemOnClick(item)) === null || _getItemOnClick === void 0 || _getItemOnClick(e);
      onItemClick === null || onItemClick === void 0 || onItemClick(e, item);
    };
    var params = _objectSpread({
      tagName: getItemTagName(item),
      label: getItemLabel(item),
      onClick: onClick,
      active: activeIndex === i,
      ref: refs[i],
      icon: getItemIcon(item),
      proportional: isProportional
    }, (_getItemAttributes = getItemAttributes(item)) !== null && _getItemAttributes !== void 0 ? _getItemAttributes : {});
    return /*#__PURE__*/React.createElement(ContextMenuItem, _extends({}, params, {
      "data-t-id": "ui-ContextMenu"
    }));
  };
  return /*#__PURE__*/React.createElement(Popover, _extends({
    anchorRef: anchorRef,
    className: function className(dir) {
      return cnContextMenu(null, [typeof _className === 'function' ? _className(dir) : _className]);
    },
    isOpen: isOpen,
    onKeyDown: onKeyDown,
    ref: combineRefs([ref, containerRef]),
    tabIndex: 0,
    theme: "dark"
  }, otherProps), items.map(function (item, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: getItemLabel(item)
    }, renderItem(item, i));
  }));
});